import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import './CreateInvoice.scss';

class CreateInvoice extends Component {
  static propTypes = {
    commissions: PropTypes.array.isRequired,
    selectedBrand: PropTypes.object,
    account: PropTypes.array,
    user: PropTypes.object,
    brandOnboardedUsers: PropTypes.array.isRequired,
    sendInvoice: PropTypes.func.isRequired
  };

  getUserIdFromCommission = commission => {
    if (!commission.cid || !commission.cid.includes('user-')) return null;
    const userId = commission.cid.replace('user-', '').split('-')[0];
    return userId ? parseInt(userId) : null;
  };

  render() {
    const { commissions, user, account, sendInvoice, selectedBrand } = this.props;
    // const userIdsOnboardedByBrandSet = new Set(
    //   this.props.brandOnboardedUsers.filter(user => user.ReferringBrand_id === commissions[0]?.Brand_id).map(i => i.id)
    // );
    const gmvTotal = _.sum(_.map(commissions, 'order_amount_usd'));
    const payoutTotal = _.sum(_.map(commissions, 'commission_amount_usd'));
    const networkFeeReal = selectedBrand?.network_rate
      ? _.sum(_.map(commissions, c => (c.commission_amount_usd * selectedBrand.network_rate) / 100))
      : selectedBrand?.network_rate_gmv_cut
      ? _.sum(_.map(commissions, c => (c.order_amount_usd * selectedBrand.network_rate_gmv_cut) / 100))
      : 0;
    const networkFee = selectedBrand?.network_rate_gmv_cut
      ? gmvTotal * (selectedBrand.network_rate_gmv_cut / 100)
      : (payoutTotal * selectedBrand.network_rate) / 100;
    const error = account ? null : 'No associated PayPal account!';
    return (
      <div className='create-invoice-outer-container'>
        <div className='ticket-header'>Invoice for {selectedBrand.name}</div>
        <div className='stats-container'>
          <div className='stat'>
            <div className='stat-header'>{commissions.length}</div>
            <div className='stat-label'>COMMISSION{commissions.length === 1 ? '' : 's'}</div>
          </div>
          <div className='stat'>
            <div className='stat-header'>${payoutTotal.toFixed(2)}</div>
            <div className='stat-label'>OWED</div>
          </div>
          {networkFee > 0 && (
            <>
              <div className='stat'>
                <div className='stat-header'>${networkFeeReal.toFixed(2)}</div>
                <div className='stat-label'>NETWORK FEE</div>
              </div>
              {networkFeeReal.toFixed(2) !== networkFee.toFixed(2) && (
                <div className='stat'>
                  <div className='stat-header'>${networkFee.toFixed(2)}</div>
                  <div className='stat-label'>NETWORK FEE (PRE-PAYING-FOR-ONBOARDED)</div>
                </div>
              )}
            </>
          )}
          <div className='stat'>
            <div className='stat-header'>{user.name}</div>
            <div className='stat-label'>CHARGED TO</div>
          </div>
        </div>
        <div className='action-btns-container'>
          <div onClick={() => sendInvoice(commissions, 'offline')} className='force-btn'>
            HANDLED OFFLINE
          </div>
          {selectedBrand?.stripeCustomerId && (
            <div onClick={() => sendInvoice(commissions, 'stripe')} className='action-btn'>
              SEND STRIPE INVOICE
            </div>
          )}
          {error ? (
            <div className='error-msg'>{error}</div>
          ) : (
            <div onClick={() => sendInvoice(commissions, 'paypal')} className='action-btn'>
              SEND PAYPAL INVOICE
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default CreateInvoice;
